import { CompanyAPI } from '@api';

const saveDriver = (form) => CompanyAPI.saveDriver(form)
  .then(({ data }) => data)
  .catch((error) => Promise.reject(error.response?.data || error.response));

export { saveDriver };
